import useLanguage from '@/utils/hooks/useLanguage';
import { UseTotalsReturn } from '@/utils/hooks/useTotals';

interface TotalsProps extends UseTotalsReturn {}

const Totals = ({ vwap, total, bidAsk, message, matchType, formatPrice }: TotalsProps) => {
    const lang = useLanguage();
    return (
        <div className="flex flex-col gap-3 text-sm">
            <div className="flex flex-row justify-between gap-2">
                <span>{lang.orderForm.vwap}</span>
                <div>{vwap ? formatPrice(vwap.toNumber()) : '-'}</div>
            </div>
            {message && <div className="text-brand-neutral-400 text-xs md:text-sm italic">{message}</div>}
            <div className="flex flex-row justify-between gap-2">
                <span>
                    {lang.orderForm.currentBest}
                    {lang.locale === 'zh' ? '' : ' '}
                    {lang.orderForm[matchType]}
                </span>
                <span className="text-right">{bidAsk ? formatPrice(bidAsk[matchType]) : '-'}</span>
            </div>
            <div className="flex flex-row justify-between gap-2">
                <span>
                    {lang.orderForm.total} ( {lang.orderForm.approx} )
                </span>
                <span className="text-right">{total}</span>
            </div>
        </div>
    );
};

export default Totals;
